import React from 'react';
import Modal from '@mui/material/Modal';
import { useTheme } from '@emotion/react';

import BottomSheet from '@/shared/components/bottom-sheet';

import { ModalWrapperStyle } from './style';
import { Props } from './types';

const ModalBottomSheet = ({ open, onOpen, onClose, children, withHandle = true, type }: Props) => {
  const [isMobile, setMobile] = React.useState(false);
  const theme = useTheme();
  const {
    breakpoints: {
      values: { sm },
    },
  } = theme;

  React.useEffect(() => {
    const onResize = () => {
      if (window.innerWidth < sm) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };
    window.addEventListener('resize', onResize, true);
    onResize();
  }, [sm]);

  return (
    <>
      <Modal open={open && !isMobile} onClose={() => onClose()}>
        <ModalWrapperStyle>{children}</ModalWrapperStyle>
      </Modal>
      <BottomSheet
        open={open && isMobile}
        onClose={() => onClose()}
        onOpen={() => onOpen()}
        withHandle={withHandle}
        type={type}
      >
        {children}
      </BottomSheet>
    </>
  );
};

export default ModalBottomSheet;
